'use client';

import { AppImageClient } from '@components/appImage';
import { Button } from '@components/button';
import { Card } from '@components/card';
import { CaseSliderCard } from '@components/casesSlider';
import { Chip } from '@components/chip';
import { Typography } from '@components/typography';
import { memo } from 'react';

import { CardLinkWrapper } from './CardLinkWrapper';

const DEFAULT_IMG_HEIGHT = 220;

export const CaseCardWeb = memo(({ card }: { card: CaseSliderCard }) => {
  return (
    <CardLinkWrapper
      card={card}
      className="relative hover:cursor-pointer max-sm:hover:cursor-default"
    >
      <Card className="relative flex flex-col gap-4 p-3" rounded="18">
        <div className="rounded-20 absolute top-0 left-0 h-full w-full bg-gradient-to-l from-[rgba(255,255,255,0.192)] to-transparent opacity-0 transition-opacity duration-300 hover:opacity-100" />
        <div
          className="pointer-events-none relative z-1 w-full overflow-hidden rounded-[12px]"
          style={{ height: card.imgHeight ?? DEFAULT_IMG_HEIGHT }}
        >
          {card.imageData ? (
            <AppImageClient
              {...card.imageData}
              alt={card.alt}
              className="object-cover"
            />
          ) : (
            // Страницы кейсов запрашивают список на клиенте, где секретов
            // imgproxy нет, поэтому там доступен только готовый signed URL
            <img
              src={card.img}
              alt={card.alt}
              className="h-full w-full object-cover"
            />
          )}
        </div>
        {card.tags?.length > 0 && (
          <div className="absolute top-[24px] left-[24px] z-1 flex flex-wrap gap-2">
            {card.tags.map((tag, index) => (
              <Chip label={tag} key={index} className="pt-2 pr-3 pb-2 pl-3" />
            ))}
          </div>
        )}
        <div className="flex flex-col gap-3 px-1">
          {card.chips?.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {card.chips.map((chip, index) => (
                <div key={index} className="flex items-center gap-1">
                  <div className="h-2 w-2 rounded-[100%] bg-[#fff]/64" />
                  <Typography
                    variant="text-s"
                    className="text-text-base-secondary flex items-center whitespace-nowrap"
                  >
                    {chip}
                  </Typography>
                </div>
              ))}
            </div>
          )}
          <div className="flex flex-col gap-2 px-1">
            <Typography
              variant="heading-s"
              className="line-clamp-2 overflow-hidden"
            >
              {card.label}
            </Typography>
            <Typography
              variant="text-m"
              className="text-text-base-secondary line-clamp-4 overflow-hidden"
            >
              {card.description}
            </Typography>
          </div>
          {card.urlArticle && (
            <Button
              className="mt-5 hidden justify-center px-4 max-sm:flex"
              variant="secondary"
            >
              {card.urlArticle}
            </Button>
          )}
        </div>
      </Card>
    </CardLinkWrapper>
  );
});

CaseCardWeb.displayName = 'CaseCardWeb';
